import { createApiClient } from "../../helpers/api-client";

export default function createPdqApi(csrf) {
    const api = createApiClient(csrf);

    return {
        async fetchAddProduct(productId) {
            return await api(
                `/discovery-queues/add-product/${productId}`,
                "GET",
            );
        },
        async fetchRemoveProduct(productId) {
            return await api(
                `/discovery-queues/remove-product/${productId}`,
                "GET",
            );
        },
    };
}
